<template>
  <div id="app">
    <!-- SCHERMATA LOGIN -->
    <transition name="fade">
      <router-view name="loginView" />
    </transition>
    <!-- APPLICAZIONE -->
    <transition name="fade">
      <div v-if="loginStates.logged">
        <!-- use the modal component, pass in the prop -->
        <transition name="modal">
          <div class="modal-mask" v-if="showModal"></div>
        </transition>
        <div class="navbar_s">
          <navbar :appStates="appStates" @qrCodeScanner="qrCodeScanner = true"></navbar>
        </div>
        <div class="container_s">
          <div class="sidebar_s" :class="{'sidebar_s_coll':appStates.collapsedSidebar} ">
            <sidebar :appStates="appStates"></sidebar>
          </div>
          <div class="main_cont_s_wrapper">
            <div class="main_cont_s">
              <router-view />
              <tendina
                :class="{'tendina_s_coll':appStates.collapsedSidebar } "
                class="tendina_s"
                :tendina_ready="curtainStates.ready"
                v-if="curtainStates.init"
                v-show="curtainStates.show"
              ></tendina>
              <sidePanel v-if="sidePanelStates.init"></sidePanel>
            </div>
          </div>
        </div>
        <!--TASTO COLLAPSE SPOSTATO NELLA SIDEBAR -->
      </div>
    </transition>
  </div>
</template>

<script>
import { EventBus } from "./main.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapState } from "vuex";
/* init_tendina : la tendina al primo avvio non viene montata per alleggerire . Una volta richiamata rimane sempre montata.*/
export default {
  name: "App",
  components: {
    VuePerfectScrollbar
  },
  computed: {
    ...mapState(["loginStates", "curtainStates", "sidePanelStates"])
  },
  data() {
    return {
      sidePanel: false,
      init_tendina: false,
      stato_tendina: false,
      tendina_ready: false,
      showModal: false,
      appStates: {
        collapsedSidebar: false
      }
    };
  },
  methods: {
    scrollHanle(evt) {
      /*this.selettore.scrolling_selettore = true;
      let self = this;
      clearTimeout(self.selettore.scrolling_delay);
      self.selettore.scrolling_delay = setTimeout(function() {
        self.selettore.scrolling_selettore = false;
      }, 100);
      let scroll = div_selettore.scrollTop;
      let posizione_scroll = div_selettore.clientHeight + scroll;
      //let altezza_scroll = div_selettore.scrollHeight;
      if (posizione_scroll >= altezza_scroll) {
        this.selettore.fine_scrolling_selettore = true;
      } else {
        this.selettore.fine_scrolling_selettore = false;
      }*/
    },
    newIntent() {
      //this.init_tendina=true
      this.$router.push(this.$route.path + "?intent=new");
      this.$store.dispatch("curtainStates/openCurtain");
    },
    chiudiTendina() {
      this.$store.dispatch("curtainStates/closeCurtain");
    }
  },

  mounted() {
    var self = this;
    EventBus.$on("mostra_modal", mostra => {
      this.showModal = mostra;
    });
  },
  watch: {
    $route() {
      //Apre la tendina se è contenuto il parametro id nella route
      //I PARAMENTRI CHE POSSONO APRIRE LA TENDINA SONO id e intent
      if (
        !_.isEmpty(this.$route.query.id) ||
        !_.isEmpty(this.$route.query.intent)
      )
        this.$store.dispatch("curtainStates/openCurtain");
      else this.$store.dispatch("curtainStates/closeCurtain", "preserveURL");

      if (!_.isEmpty(this.$route.query.checkout)) {
        this.$store.dispatch("sidePanelStates/openPanel");
      } else {
        this.$store.dispatch("sidePanelStates/closePanel", "preserveURL");
      }
    }
  }
};
</script>

<style>
@import "./css/shared.css";
</style>


<style lang="scss" scoped>
/*STILI con estensione _s per distinguerli da quelli di bootstrap*/
$sidebar_width: 15.6;
$coll_sidebar_width: 6;
//sisteamre anche nella tendina in modo che vadano alla pari
$revealSidebarTime: 0.5s;
$collapseSidebarTime: 0.5s;

#app {
  font-size: 0.875rem;
  background-color: #e9e9e9;
  overflow: hidden;
}
.navbar_s {
  height: 10vh;
  width: 100%;
  background-color: #039be5;
}
.container_s {
  display: flex;
  flex-wrap: nowrap;
  height: 90vh;
}
.sidebar_s {
  width: $sidebar_width + 0vw;
  -moz-transition: width $revealSidebarTime ease-in-out,
    left $collapseSidebarTime ease-in-out;
  -webkit-transition: width $revealSidebarTime ease-in-out,
    left $revealSidebarTime ease-in-out;
  -moz-transition: width $revealSidebarTime ease-in-out,
    left $revealSidebarTime ease-in-out;
  -o-transition: width $revealSidebarTime ease-in-out,
    left $revealSidebarTime ease-in-out;
  transition: width $revealSidebarTime ease-in-out,
    left $revealSidebarTime ease-in-out;
}
.main_cont_s_wrapper {
  background-color: #039be5;
  flex-basis: 300vw; /*METTERE 100% ?? */
}
.main_cont_s {
  background-color: #f8f8f8;
  border-color: #18212a;
  border-width: 0;
  border-top-left-radius: 1.5vw !important;
  height: 90vh;
}
.tendina_s {
  position: fixed;
  left: $sidebar_width + 0vw;
  bottom: 0;
  margin-left: 0vw;
  right: 0;
  border-top-left-radius: 1.5vw !important;
  -moz-transition: width $collapseSidebarTime ease-in-out,
    left $collapseSidebarTime ease-in-out;
  -webkit-transition: width $collapseSidebarTime ease-in-out,
    left $collapseSidebarTime ease-in-out;
  -moz-transition: width $collapseSidebarTime ease-in-out,
    left $collapseSidebarTime ease-in-out;
  -o-transition: width $collapseSidebarTime ease-in-out,
    left $collapseSidebarTime ease-in-out;
  transition: width $collapseSidebarTime ease-in-out,
    left $collapseSidebarTime ease-in-out;
}
/*COLLAPSE OVERRIDES*/
.sidebar_s_coll {
  width: $coll_sidebar_width + 0vw !important;
  -moz-transition: width $collapseSidebarTime ease-in-out,
    left $collapseSidebarTime ease-in-out;
  -webkit-transition: width $collapseSidebarTime ease-in-out,
    left $collapseSidebarTime ease-in-out;
  -moz-transition: width $collapseSidebarTime ease-in-out,
    left $collapseSidebarTime ease-in-out;
  -o-transition: width $collapseSidebarTime ease-in-out,
    left $collapseSidebarTime ease-in-out;
  transition: width $collapseSidebarTime ease-in-out,
    left $collapseSidebarTime ease-in-out;
}
.tendina_s_coll {
  left: $coll_sidebar_width + 0vw !important;
}

.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
}
.fade-enter-active,
.fade-leave-active {
  transition: 0.9s;
}
.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
}
.modal-mask {
  position: absolute;
  z-index: 9997;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.swal2-container {
  z-index: 99999999 !important;
}
</style>
